import { render, staticRenderFns } from "./VerRequisicion.vue?vue&type=template&id=78f5ce5a&scoped=true"
import script from "./VerRequisicion.vue?vue&type=script&lang=js"
export * from "./VerRequisicion.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VerRequisicion.vue?vue&type=style&index=1&id=78f5ce5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f5ce5a",
  null
  
)

export default component.exports